import { render, staticRenderFns } from "./LessonCreate.vue?vue&type=template&id=5198cfa0"
import script from "./LessonCreate.vue?vue&type=script&lang=js"
export * from "./LessonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports